import React, { useCallback, useState } from 'react'
import { Alert } from 'components'
import { alerts as alertKeys } from 'keys'
import { AutoComplete, Input } from 'components/Form'
import { SmallSpace } from 'styles/GlobalStyle'
import { useAlert } from 'components/Alerts/hooks'
import { useSelector } from 'react-redux'
import { useQueryClient } from '@tanstack/react-query'
import { semesterAndYearOptions } from 'keys/years'
import { getCurrentSchoolYear } from 'utils/general'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import qc from 'keys/queryClient'

const AddShortSchoolClass = () => {
    const { setAlerts } = useAlert()
    const { alerts } = useSelector(state => state.general)

    const currentSchoolYear = getCurrentSchoolYear()

    const [tClass, setTClass] = useState(null)
    const [schoolYear, setSchoolYear] = useState(currentSchoolYear)

    const action = alerts[alertKeys.createShortClass]?.props.action

    const queryClient = useQueryClient()

    const handleAlert = useCallback((val) => {
        setAlerts(alertKeys.createShortClass, val)
    }, [])

    const addSchoolClass = useCallback(async () => {
        if (!schoolYear) {
            toast.error("חובה לבחור שנת לימודים", toastConfig)
            return
        }

        const { affiliation, grade } = alerts[alertKeys.createShortClass]?.props
        handleAlert(false)
        await action({
            name: tClass,
            affiliation: affiliation,
            grade: grade,
            school_year: schoolYear?.id || schoolYear
        })
        queryClient.invalidateQueries({ queryKey: [qc.affiliationGrades, affiliation] })
    }, [tClass, schoolYear, alerts[alertKeys.createShortClass]])

    const footerActions = React.useMemo(
        () => [
            { label: "שמירה", variant: "regular", color: "thirdly", action: addSchoolClass },
            { label: "ביטול", variant: "white", color: "thirdly4", action: () => handleAlert(false) }
        ], [tClass, schoolYear, alerts[alertKeys.createShortClass]]
    )

    return (
        <Alert
            systemUI
            title={"הוספת כיתה"}
            footerActions={footerActions}
            handleAlert={handleAlert}
        >
            <SmallSpace />
            <Input
                input={{
                    value: tClass,
                    onChange: setTClass
                }}
                placeholder="בחר מספר כיתה"
            />
            <SmallSpace />
            <AutoComplete
                name="role"
                options={semesterAndYearOptions}
                hideClear
                placeholder="שנת לימודים"
                input={{
                    value: schoolYear,
                    onChange: setSchoolYear
                }}
                labelKey="label"
            />
        </Alert>
    )
}

export default AddShortSchoolClass